import { DororaidIcon } from '../../../shared/ui/DororaidIcon.jsx';
import './raid-chat-history-controls.css';

export function RaidChatHistoryControls({ room, onLoadOlder }) {
  return <div className="raid-control-history-controls">
    <div className="raid-control-history-actions">
      {room.historyLoading ? <span role="status">이전 채팅 불러오는 중…</span>
        : room.hasOlderMessages ? <button type="button" className="raid-control-history-action" onClick={onLoadOlder}>
          <DororaidIcon name="chevronUp" size={14} /><span>{room.historyError ? '다시 시도' : '이전 채팅 보기'}</span>
        </button> : <span>첫 채팅입니다</span>}
      {room.historyMode ? <button type="button" className="raid-control-history-action" onClick={room.showLatestMessages}>
        <span>최신 메시지</span><DororaidIcon name="chevronDown" size={14} />
      </button> : null}
    </div>
    {room.historyError ? <span className="raid-control-history-error" role="alert">{room.historyError}</span> : null}
  </div>;
}
